/* @flow */

export const NEW_TOPIC_KEYWORDS = 'NEW_TOPIC_KEYWORDS';
export const NEW_TOPIC_RECOMMENDED_KEYWORDS = 'NEW_TOPIC_RECOMMENDED_KEYWORDS';
